import { get } from 'lodash'

import type { CloudMarketplace } from '../../productsListing/types'
import type { Contract } from '../types'

export const getSendContractsV2ObjectToSend = (
  contractsData: Contract[],
  payload: Record<string, unknown>,
  selectedCloudProvider: CloudMarketplace
): Record<string, unknown> =>
  selectedCloudProvider === 'AWS'
    ? payload
    : selectedCloudProvider === 'AZURE'
      ? payload
      : ({
          cloud_marketplace: get(contractsData, '[0].cloudMarketplace'),
          cloud_marketplace_product_id: get(
            contractsData,
            '[0].cloudMarketplaceProductId'
          ),
          product_id: get(contractsData, '[0].productId'),
          usage: payload,
        } as Record<string, unknown>)
